var _path, _path2, _circle, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgXlsxFile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 52,
    viewBox: "0 0 38 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.26 43.4717H5.98576C5.48863 43.469 4.99747 43.369 4.54328 43.1778C4.08909 42.9866 3.68174 42.7084 3.34694 42.3607C2.63169 41.6331 2.23776 40.6742 2.2459 39.6807L2 8.56116L5.83896 5.39506L11.1753 1H30.26C30.7571 1.00261 31.2483 1.10268 31.7025 1.29389C32.1567 1.4851 32.564 1.76329 32.8988 2.11091C33.6141 2.83857 34.008 3.79744 33.9999 4.791V39.6807C34.008 40.6742 33.6141 41.6331 32.8988 42.3607C32.564 42.7084 32.1567 42.9866 31.7025 43.1778C31.2483 43.369 30.7571 43.469 30.26 43.4717ZM11.1753 1.4652L2 8.56116L9.35227 8.72008C10.504 8.74497 11.4386 7.79422 11.394 6.64308L11.1937 1.47561L11.1753 1.4652Z",
    fill: "#303030"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.56116L2.2459 39.6807C2.23776 40.6742 2.63169 41.6331 3.34694 42.3607C3.68174 42.7084 4.08909 42.9866 4.54328 43.1778C4.99747 43.369 5.48863 43.469 5.98576 43.4717H30.26C30.7571 43.469 31.2483 43.369 31.7025 43.1778C32.1567 42.9866 32.564 42.7084 32.8988 42.3607C33.6141 41.6331 34.008 40.6742 33.9999 39.6807V4.791C34.008 3.79744 33.6141 2.83857 32.8988 2.11091C32.564 1.76329 32.1567 1.4851 31.7025 1.29389C31.2483 1.10268 30.7571 1.00261 30.26 1H11.1753L5.83896 5.39506L2 8.56116ZM2 8.56116L11.1753 1.4652L11.1937 1.47561L11.394 6.64308C11.4386 7.79422 10.504 8.74497 9.35227 8.72008L2 8.56116Z",
    stroke: "#747272",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 41,
    r: 11,
    fill: "#5FBDA7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8125 39.7168L25.6865 41.3232L26.585 39.7168H28.084L26.5898 42.2998L28.1523 45H26.6484L25.6963 43.3008L24.7441 45H23.2402L24.8027 42.2998L23.3086 39.7168H24.8125ZM30.252 37.5V45H28.8408V37.5H30.252Z",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.207 2H30.4584C32.0504 2 33.2615 3.42959 32.9997 5H12.3106L12.207 2Z",
    fill: "#5FBDA7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2051 13H16.1621V15.3395H21.2051V13Z",
    fill: "#5FBDA7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3653 13H22.3223V15.3395H27.3653V13Z",
    fill: "#5FBDA7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2051 16.3857H16.1621V18.7253H21.2051V16.3857Z",
    fill: "#5FBDA7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3653 16.3857H22.3223V18.7253H27.3653V16.3857Z",
    fill: "#5FBDA7"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2051 19.7725H16.1621V22.112H21.2051V19.7725Z",
    fill: "#5FBDA7"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3653 19.7725H22.3223V22.112H27.3653V19.7725Z",
    fill: "#5FBDA7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.043 19.7725H10V22.112H15.043V19.7725Z",
    fill: "#5FBDA7"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2051 23.1592H16.1621V25.4987H21.2051V23.1592Z",
    fill: "#5FBDA7"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3653 23.1592H22.3223V25.4987H27.3653V23.1592Z",
    fill: "#5FBDA7"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M15.043 23.1592H10V25.4987H15.043V23.1592Z",
    fill: "#5FBDA7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9693 18.434H13.4536L12.5032 16.9168L11.5649 18.434H10.0703L11.6846 15.9412L10.1658 13.5547H11.6255L12.5062 15.0719L13.3505 13.5547H14.8526L13.3111 16.0444L14.9693 18.434Z",
    fill: "#5FBDA7"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxFile);
export default __webpack_public_path__ + "static/media/xlsx-file.c5946d123acb6e4391095861a170871e.svg";
export { ForwardRef as ReactComponent };